export * from './lib/ui-footer.module';
